<template>
  <div class="user-base">
    <nav-menu />
    <div class="user-right">
      <nav-header />
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>

import NavMenu from "@/views/User/Common/Home/NavMenu";
import NavHeader from "@/views/User/Common/Home/Navheader";
export default {
  name: "User",
  components: {NavHeader, NavMenu},
  data(){
    return{
      Index:1,
    }
  },
  methods:{
    handleOpen(key, keyPath) {
      this.$router.push(key)
    },
    GetIndex(index){
      this.$router.push(index)
    }
  }

}
</script>

<style lang="less" scoped>
//.el-scrollbar__wrap {
//  overflow-y: hidden;
//}
.user-base{
  display: flex;
  .user-right{
    width: 88vw;
    background: #FFFFFF;
    height: 100vh;
    padding-left: 10px;
  }
}
</style>